import BaseField from "../ui/BaseField";
import ValueWithFallback from "../ui/ValueWithFallback";
import FormatCurrency from "../utils/FormatCurrency";

const RunningTotal = ({ fieldName, value, flag, clock }) => {
  return (
    <BaseField
      id="SB-Running-Total"
      testId="SB-Running-Total"
      fieldName={fieldName}
      label={"Received Bill Charges"}
      flag={flag}
      clock={clock}
    >
      <span className="font-bold">{FormatCurrency(ValueWithFallback(value))}</span>
    </BaseField>
  );
};

export default RunningTotal;
